// Allow deselecting variant option buttons by clicking the selected option again.
// Uses capture phase to intercept before the outer .pdp_selector-block label
// re-checks the radio (which is what caused the previous fix to fail).
document.addEventListener('click', function(e) {
  var outerLabel = e.target.closest('label.pdp_selector-block');
  if (!outerLabel) return;

  var radioId = outerLabel.getAttribute('for');
  var radio = radioId ? document.getElementById(radioId) : null;
  if (!radio || !radio.checked) return; // not selected yet — let normal select flow run

  // Already selected — handle deselect
  e.preventDefault();
  e.stopPropagation();

  radio.checked = false;

  // Restore default variant selection
  var defaultInput = document.querySelector('.pdp_selector-input__default');
  if (defaultInput) {
    defaultInput.checked = true;
    var productPrice = defaultInput.getAttribute('data-product-price');
    if (productPrice) {
      document.querySelectorAll('.pdp__price').forEach(function(el) {
        el.innerHTML = productPrice;
      });
    }
  }

  // Reset hidden variant_id field if present
  var form = outerLabel.closest('form');
  if (form && defaultInput) {
    var variantIdField = form.querySelector('.variant_id');
    if (variantIdField) variantIdField.value = defaultInput.value;
  }
}, true); // true = capture phase

// ---------------------------------------------------------------------------
// Shop Pay variant fix for the "Select a model" (variant-button) PDP.
//
// On that PDP the visible model selector is a radio group where EVERY radio is
// name="id" (14" Pit Barrel Junior, 18.5", 22.5" PBX, ...). Shopify's dynamic
// checkout button ("Buy with Shop Pay") reads the FIRST name="id" element in the
// form, which is the default variant's radio (Pit Barrel Junior) — so Shop Pay
// always checked out Pit Barrel Junior no matter which model the customer
// selected, even though Add to Cart (which reads the *checked* radio) was correct.
//
// sections/product-template.liquid now renders a single hidden name="id" master
// input FIRST in the form. This keeps that master in sync with the checked radio
// and notifies the payment button, so every checkout path uses the same variant.
(function() {
  var RADIO_SEL = '.variant-wrapper .variant-input input[type="radio"][name="id"]';
  var MASTER_SEL = 'input.js-shoppay-master-id[name="id"]';

  function syncMaster(form) {
    if (!form) return;
    var master = form.querySelector(MASTER_SEL);
    if (!master) return;
    var checked = form.querySelector(RADIO_SEL + ':checked');
    if (!checked || master.value === checked.value) return;
    master.value = checked.value;
    master.dispatchEvent(new Event('input', { bubbles: true }));
    master.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Native radio change (label clicks, and programmatic dispatches such as
  // notify-button-fix.js mirroring the mobile selection onto the desktop form).
  document.addEventListener('change', function(e) {
    var radio = e.target && e.target.closest ? e.target.closest(RADIO_SEL) : null;
    if (radio) syncMaster(radio.closest('form'));
  });

  // Belt-and-suspenders: also sync after a model label click, in case a browser
  // does not fire a bubbling change for the label->radio toggle.
  document.addEventListener('click', function(e) {
    var label = e.target && e.target.closest
      ? e.target.closest('.variant__button-label, .js-variant')
      : null;
    if (!label) return;
    var form = label.closest('form');
    if (form) setTimeout(function() { syncMaster(form); }, 0);
  });

  // Initialize each master to whatever variant is pre-checked on load.
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('form ' + MASTER_SEL).forEach(function(master) {
      syncMaster(master.closest('form'));
    });
  });
})();

document.addEventListener("DOMContentLoaded", function () {

  // Review Slider
  var reviewContainer = document.querySelector(".expertReviews-block-slider");
  if (reviewContainer) {
    var reviewSlides = reviewContainer.querySelectorAll(".swiper-slide");
    var swiper = new Swiper(".expertReviews-block-slider", {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: reviewSlides.length > 1,
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
      },
      navigation: {
        nextEl: ".swiper-button-next-reviews",
        prevEl: ".swiper-button-prev-reviews",
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
      },
    });
  }


  // Featured Products Carousel (mobile/tablet only)
  var cfpCarousels = document.querySelectorAll(".cfp-carousel");
  if (cfpCarousels.length > 0) {
    var mq = window.matchMedia("(max-width: 991px)");

    cfpCarousels.forEach(function (carouselEl) {
      var swiperInstance = null;
      var gridEl = carouselEl.querySelector(".cfp-carousel-grid");
      var gridItems = carouselEl.querySelectorAll(".cfp-carousel-grid > .grid__item");
      var navEl = carouselEl.querySelector(".cfp-carousel-nav");

      function updateNavVisibility() {
        if (!navEl) return;
        if (swiperInstance && swiperInstance.isLocked) {
          navEl.style.display = "none";
        } else {
          navEl.style.display = "";
        }
      }

      function initCarousel() {
        if (swiperInstance) return;
        carouselEl.classList.add("swiper");
        if (gridEl) gridEl.classList.add("swiper-wrapper");
        gridItems.forEach(function (item) {
          item.classList.add("swiper-slide");
        });
        swiperInstance = new Swiper(carouselEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          watchOverflow: true,
          centerInsufficientSlides: true,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: carouselEl.querySelector(".cfp-carousel-next"),
            prevEl: carouselEl.querySelector(".cfp-carousel-prev"),
          },
          breakpoints: {
            576: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 3,
            },
          },
          on: {
            lock: updateNavVisibility,
            unlock: updateNavVisibility,
            resize: updateNavVisibility,
          },
        });
        updateNavVisibility();
      }

      function destroyCarousel() {
        if (!swiperInstance) return;
        swiperInstance.destroy(true, true);
        swiperInstance = null;
        carouselEl.classList.remove("swiper");
        if (gridEl) gridEl.classList.remove("swiper-wrapper");
        gridItems.forEach(function (item) {
          item.classList.remove("swiper-slide");
        });
        // Remove any inline styles Swiper may have left
        if (gridEl) gridEl.removeAttribute("style");
        gridItems.forEach(function (item) {
          item.removeAttribute("style");
        });
        // Reset nav visibility (CSS hides it on desktop via display:none)
        if (navEl) navEl.style.display = "";
      }

      function handleViewportChange(e) {
        if (e.matches) {
          initCarousel();
        } else {
          destroyCarousel();
        }
      }

      mq.addEventListener("change", handleViewportChange);
      handleViewportChange(mq);
    });
  }


  // Video Slider
  var videoContainer = document.querySelector(".videoProduct-block");
  if (videoContainer) {
    var videoSlides = videoContainer.querySelectorAll(".swiper-slide");
    var swiper2 = new Swiper(".videoProduct-block", {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: videoSlides.length > 4,
      breakpoints: {
        399: {
          slidesPerView: 1.5,
          spaceBetween: 10,
        },
        499: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        640: {
          slidesPerView: 2.5,
          spaceBetween: 15,
        },
        786: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1099: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
  }

});
